<template>
  <div class="Component" 
    @mousedown="touchStart($event)"
    @mousemove="mouseMove($event)"
    @mouseup="touchEnd($event)"
    @touchstart="touchStart($event)" 
    @touchmove="mouseMove($event)" 
    @touchend="touchEnd($event)"> 
    <canvas id="canvas"></canvas>
    <div class="Component__txt">{{ txt }}</div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Component',
  render: h => h(), 
  data: ()=>({
    txt: '',
    isPainting: false,
    startX: 0,
    startY: 0,
    ctx: null,
    canvasOffsetX: null,
    canvasOffsetY: null,
    lineWidth: 20
  }),
  mounted() {
    this.$nextTick(()=>{
      this.init()
    })
  },
  methods: {

    touchStart(e) {
      this.isPainting = true
      this.startX = e.clientX
      this.startY = e.clientY
    },
    touchEnd(e) {
      this.isPainting = false
      this.ctx.stroke()
      this.ctx.beginPath()
    },
    mouseMove(e) {
    
      if(!this.isPainting) {
        return;
      }

      this.ctx.fillStyle = '#db2000'
      this.ctx.lineWidth = this.lineWidth
      this.ctx.lineCap = 'round'

      var x = e.layerX - this.canvasOffsetX;
      var y = e.layerY - this.canvasOffsetY;

      // this.ctx.lineTo(e.layerX - this.canvasOffsetX, e.layerY)
      this.ctx.lineTo(x, y)  
      // this.ctx.arc(x, y, 1, 0, Math.PI * 2, false)
      this.ctx.stroke()
    },

    init() {
      const canvas = document.getElementById('canvas')
      this.ctx = canvas.getContext('2d')
      this.canvasOffsetX = canvas.offsetLeft
      this.canvasOffsetY = canvas.offsetTop
      canvas.width = window.innerWidth - this.canvasOffsetX
      canvas.height = window.innerHeight - this.canvasOffsetY
    },
  }

}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Component
  position fixed 
  top 0 
  left 0
  width 100vw
  height 100vh
  overflow hidden

  &__txt 
    position absolute
    top 0px
    left 0px
    background red
    color white
    width 120px
    height 30px
    padding 0 12px
    font-size .8em
    display flex
    align-items center

 & canvas 
    position absolute
    top 0px
    left 0px
    width 100%
    height 100%

</style>















